export default __webpack_public_path__ + "static/media/audio_43_pasos_corriendo.32d2a02c.mp3";